import { useState, useEffect } from "react";
import axios from "../api/axiosInstance";

export default function AdminEmergencyContact() {
  const [phone, setPhone] = useState("");
  const [saved, setSaved] = useState(false);
const [pharmacists, setPharmacists] = useState([]);
const [selectedId, setSelectedId] = useState("");
const [phPhone, setPhPhone] = useState("");
const [start, setStart] = useState("");
const [end, setEnd] = useState("");

const save = async () => {
  await axios.post("/admin/emergency-contact/save/", { phone });
  alert("Saved");
};

useEffect(() => {
  fetchAdminPhone();
}, []);
const fetchAdminPhone = async () => {
  const res = await axios.get("/admin/emergency-contact/get/");
  setPhone(res.data.phone || "");
};

useEffect(() => {
  fetchAdminPhone();
  fetchPharmacists();
}, []);
const fetchPharmacists = async () => {
  const res = await axios.get("/admin/pharmacists/list/");

  // Sirf internal pharmacists + timing mapping
  const onlyInternal = res.data
    .filter(p => {
      if (p.pharmacist_type) {
        return p.pharmacist_type === "internal";
      }
      return true;
    })
    .map(p => ({
      ...p,
      start: p.duty_start_time || "",
      end: p.duty_end_time || "",
    }));

  setPharmacists(onlyInternal);
};



const savePharmacist = async () => {
  await axios.post(`/admin/pharmacist/${selectedId}/update/`, {
    phone: phPhone,
    start,
    end,
  });
if (!selectedId) {
  alert("Select a pharmacist first");
  return;
}

  fetchPharmacists();
  alert("Updated");
};


  return (
    <div style={{ maxWidth: "400px" }}>
      <h2>Emergency Admin Contact</h2>

      <input
        type="tel"
        placeholder="Admin phone number"
        value={phone}
        onChange={(e) => setPhone(e.target.value)}
        style={{
          width: "100%",
          padding: "10px",
          marginBottom: "10px",
        }}
      />

      <button
        onClick={save}
        style={{
          width: "100%",
          padding: "10px",
        }}
      >
        Save
      </button>
<button onClick={save}>
  {phone ? "Update" : "Save"}
</button>
<h3>Saved Pharmacist Contacts</h3>	

<select
  value={selectedId}
  onChange={(e) => {
    const id = e.target.value;
    setSelectedId(id);
    const p = pharmacists.find(x => x.id == id);
    if (p) {
      setPhPhone(p.phone || "");
      setStart(p.start || "");
      setEnd(p.end || "");
    }
  }}
>
  <option value="">Select Pharmacist</option>
  {pharmacists.map(p => (
    <option key={p.id} value={p.id}>{p.name}</option>
  ))}
</select>
<input value={phPhone} onChange={e=>setPhPhone(e.target.value)} placeholder="Phone" />
<input type="time" value={start} onChange={e=>setStart(e.target.value)} />
<input type="time" value={end} onChange={e=>setEnd(e.target.value)} />

{pharmacists.map(p => (
  <div key={p.id} style={{border:"1px solid #ccc", margin:"5px", padding:"5px"}}>
    <b>{p.name}</b><br/>
    📞 {p.phone || "Not set"}<br/>
    ⏰ {p.start || "--"} - {p.end || "--"}
<button onClick={()=>{
  setSelectedId(p.id);
  setPhPhone(p.phone || "");
  setStart(p.start || "");
  setEnd(p.end || "");
}}>
  Edit
</button>

  </div>
))}
<button
  onClick={savePharmacist}
  disabled={!selectedId}
  style={{ marginTop: "10px", padding: "6px 12px" }}
>
  Update Pharmacist
</button>

      {saved && <p style={{ color: "green" }}>Saved successfully</p>}
    </div>
  );
}
